import axios from "axios";
import { base_url, headers } from "../constants";

// ---------- CREATE WATCHLIST
export const createWatchlist = async (body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const market = sessionStorage.getItem("selectedMarket") ?? "US";
        const response = await axios.post(
            `${base_url}/api/v1/watchlists`,
            { ...body, market_code: market },
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Create watchlist error:", error);
        return { success: false, error };
    }
};

// ---------- GET ALL WATCHLISTS
export const getAllWatchlists = async () => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const market = sessionStorage.getItem("selectedMarket") ?? "US";
        const response = await axios.get(
            `${base_url}/api/v1/watchlists`,
            {
                params: { market_code: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get watchlists error:", error);
        return { success: false, error };
    }
};

// ---------- GET WATCHLIST BY ID
export const getWatchlistById = async (watchlistId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.get(
            `${base_url}/api/v1/watchlists/${watchlistId}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get watchlist by ID error:", error);
        return { success: false, error };
    }
};

// ---------- UPDATE WATCHLIST
export const updateWatchlist = async (watchlistId, body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.patch(
            `${base_url}/api/v1/watchlists/${watchlistId}`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Update watchlist error:", error);
        return { success: false, error };
    }
};

// ---------- DELETE WATCHLIST
export const deleteWatchlist = async (watchlistId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/watchlists/${watchlistId}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true }
            : { success: false };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Delete watchlist error:", error);
        return { success: false, error };
    }
};

// ---------- ADD STOCK TO WATCHLIST
export const addStockToWatchlist = async (watchlistId, body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.post(
            `${base_url}/api/v1/watchlists/${watchlistId}/stocks`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Add stock to watchlist error:", error);
        return { success: false, error };
    }
};

// ---------- REMOVE STOCK FROM WATCHLIST
export const removeStockFromWatchlist = async (watchlistId, ticker) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/watchlists/${watchlistId}/stocks/${ticker}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return [200, 204].includes(response.status)
            ? { success: true }
            : { success: false };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Remove stock error:", error);
        return { success: false, error };
    }
};

// ---------- BULK ADD TO WATCHLIST
export const bulkAddToWatchlist = async (watchlistId, stocks) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.post(
            `${base_url}/api/v1/watchlists/${watchlistId}/stocks/batch`,  // ✅ /batch added
            { stocks },                                                     // ✅ wrapped in { stocks: [...] }
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Bulk add stocks to watchlist error:", error);
        return { success: false, error };
    }
};
